const Admin = (app) => {
  app.post(
    "/admin-panel/manage-category",
    async ({ req, assert, res, api, flash }) => {
      const { body } = req;

      const { categoryId, category, newCategory = false } = body;

      assert(category, 400, "You need to provide a category name");

      if (!newCategory) {
        assert(categoryId, 400, "You need to provide a category id");
      }

      const method = newCategory ? "POST" : "PUT";

      await api(`tutorial-categories`, {
        method,
        body,
      });

      flash(
        "success",
        `Category ${newCategory ? "created" : "changes saved"} succesfully`
      );

      res.refreshWith(
        {
          "modal[type]": "",
          category,
          selectedCategoryIndex: "",
          selectedCategoryId: "",
          newCategory: "",
        },
        { url: "back", hash: "#_" }
      );
    }
  );

  app.post(
    "/admin-panel/manage-category/sort",
    async ({ req, assert, res, api, flash }) => {
      const { body } = req;

      const { sortedCategories } = body;

      assert(sortedCategories, 400, "You need to provide a category name");

      try {
        await api(`tutorial-categories-sort`, {
          method: "POST",
          body,
        });

        flash("success", `Sorted successfully`);
      } catch (err) {
        flash("error", `Error sorting categories`);
      }

      res.refreshWith(
        {
          "modal[type]": "",
        },
        { url: "back", hash: "#_" }
      );
    }
  );

  app.post(
    "/admin-panel/manage-category/delete",
    async ({ req, assert, res, api, flash }) => {
      const { body } = req;

      const { category, product } = body;

      assert(category !== "All", 400, "You can't delete the All category");

      assert(category, 400, "You need to provide a category name");
      assert(product, 400, "You need to provide a product name");

      try {
        await api(
          `tutorial-categories?category=${category}&product=${product}`,
          {
            method: "DELETE",
          }
        );

        flash(
          "success",
          `Category ${category} for ${product} removed successfully`
        );
      } catch (err) {
        flash("error", `Error removing category ${category} for ${product}`);
      }

      res.refreshWith(
        {
          "modal[type]": "",
          category: "All",
          selectedCategoryIndex: "all",
        },
        { url: "back", hash: "#_" }
      );
    }
  );

  app.post(
    "/admin-panel/manage-category/video",
    async ({ req, assert, res, api, flash }) => {
      const { body } = req;

      const { category, name, url, description, product } = body;

      assert(name, 400, "You need to provide a video title");
      assert(url, 400, "You need to provide a video url");
      assert(description, 400, "You need to provide a video description");
      assert(category, 400, "You need to provide a category");
      assert(product, 400, "You need to provide a product");

      const loomRegexp = /(https:\/\/)www.loom.com\/share\/(.+)/gim;
      const match = url.match(loomRegexp);
      assert(match, 400, "You need to provide a valid loom url");

      try {
        await api("tutorial-categories-videos", {
          method: "POST",
          body,
        });

        flash("success", `Video added succesfully`);
      } catch (err) {
        flash("error", "Error adding video");
      }

      res.refreshWith(
        {
          "modal[type]": "",
          selectedTutorial: "",
        },
        { url: "back", hash: "#_" }
      );
    }
  );

  app.post(
    "/admin-panel/manage-category/video/update",
    async ({ req, assert, res, api, flash }) => {
      const { body } = req;
      const { video, url } = body;
      assert(video, 400, "You need to provide a video");

      if (url) {
        const loomRegexp = /(https:\/\/)www.loom.com\/share\/(.+)/gim;
        const match = url.match(loomRegexp);
        assert(match, 400, "You need to provide a valid loom url");
      }

      try {
        await api("tutorial-categories-videos", {
          method: "PUT",
          body,
        });

        flash("success", `Video modified succesfully`);
      } catch (err) {
        flash("error", "Error modifying video");
      }

      res.refreshWith(
        {
          "modal[type]": "",
          selectedTutorial: "",
        },
        { url: "back", hash: "#_" }
      );
    }
  );

  app.post(
    "/admin-panel/manage-category/video/delete",
    async ({ req, assert, res, api, flash }) => {
      const { body } = req;

      const { tutorialId } = body;

      assert(tutorialId, 400, "You need to provide a tutorial/video id");

      try {
        await api(`tutorial-categories-videos?tutorialId=${tutorialId}`, {
          method: "DELETE",
        });

        flash("success", `Tutorial deleted succesfully`);
      } catch (err) {
        flash("error", "Error deleting tutorial");
      }

      res.refreshWith(
        {
          "modal[type]": "",
          selectedTutorial: "",
        },
        { url: "back", hash: "#_" }
      );
    }
  );
};

export default Admin;
